import type { HashtagSummary, Video } from '@blackblack/shared';
import { formatCount } from '@blackblack/shared';
import { api } from '../../lib/api';
import { useInfinite, useQuery } from '../../lib/query';
import { useParams } from '../../lib/router';
import { EmptyState } from '../../components/ui/primitives';
import { Page, PageHeader } from '../../components/layout';
import { VideoGrid } from '../../components/VideoGrid';
import styles from './discover.module.css';

export function HashtagPage() {
  const { tag } = useParams<{ tag: string }>();
  const info = useQuery<HashtagSummary>(`hashtag:${tag}`, () => api.get(`/hashtags/${encodeURIComponent(tag)}`));
  const videos = useInfinite<Video>(`hashtag-videos:${tag}`, (cursor) => api.page<Video>(`/hashtags/${encodeURIComponent(tag)}/videos`, { cursor }));
  return (
    <Page>
      <PageHeader title={`#${tag}`} fallback="/discover" />
      <div className={styles.tagHero}>
        <span className={styles.tagBadge}>#</span>
        <div>
          <h1>#{tag}</h1>
          <p>{info.data ? `${formatCount(info.data.videoCount)} video's` : ' '}</p>
        </div>
      </div>
      <VideoGrid
        items={videos.items}
        loading={videos.initialLoading}
        hasMore={videos.hasMore}
        loadingMore={videos.loading}
        onLoadMore={videos.loadMore}
        empty={<EmptyState icon="hash" title="Nog geen video's" text={`Gebruik #${tag} in je caption om hier te verschijnen.`} />}
      />
    </Page>
  );
}
